<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-row>
            <b-col cols="12" class="mb-2">
                <b-button variant="success">Add User</b-button>
            </b-col>
            <b-col>
                <webix-ui :config="ui" v-model="users"></webix-ui>
            </b-col>
        </b-row>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Users",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
        users:[],
        ui:{
            id: 'usersTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            columns:[
                { id:"id", header:"", hidden: true, fillspace: 0},
                { id:"name", header:"Name", fillspace: true},
                { id:"code", header:"Code", fillspace:1},
                { id:"group", header:"Group", fillspace:1},
                { id:"description", header:"Description", fillspace:1},
                { id:"revision", header:"Revision", fillspace:1},
                { id:"date_modified", header:"Date Modified", fillspace:1},
                { id:"actions", header:"Actions", fillspace:1},
            ],
            on: {
                onItemClick(id){
                    var item = this.getItem(id)
                    console.log(item)
                    /*var el = this.$scope.$parent;
                    var index = _.findIndex(el.milestone_data, {id:item.id});
                    if(index != -1){
                        el.selected_milestone = _.cloneDeep(el.milestone_data[index]);
                        el.$eventHub.$emit('selectedMilestone', el.selected_milestone);
                    }*/
                }
            },
            onClick:{},
        },
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
    };
  },
  mounted() {

  },
};
</script>

<style>

</style>


